import { useResetEnvironment } from "@/entities/utils";
import { Button, ConfirmDialog } from "@/shared/components";
import { useState } from "react";

export function ResetEnvironment() {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const resetEnvironment = useResetEnvironment();

    function handleReset() {
        resetEnvironment.mutate(undefined, {
            onSuccess: () => setConfirmOpen(false),
        });
    }

    return (
        <div className="grid gap-2">
            <h3 className="text-l text-content-emphasis">Omgeving opschonen</h3>
            <div>
                <Button destructive onClick={() => setConfirmOpen(true)}>
                    Verwijder alles
                </Button>
            </div>
            <ConfirmDialog
                isOpen={confirmOpen}
                onCancel={() => setConfirmOpen(false)}
                onConfirm={handleReset}
                isPending={resetEnvironment.isPending}
                error={resetEnvironment.error}
                title="Omgeving opschonen"
                destructive
            >
                Weet je <b>heel</b> zeker dat je alle dossiers, ongewenste gebeurtenissen en gerelateerde objecten wilt verwijderen? Doe je
                dit op het verkeerde moment dan kan dat desastreuze gevolgen hebben. Dit kan niet ongedaan gemaakt worden.
            </ConfirmDialog>
        </div>
    );
}
